import * as React from 'react';
export default function TabPanel(_ref) {
  var children = _ref.children,
      shouldShow = _ref.shouldShow,
      tabId = _ref.tabId;
  return React.createElement("div", {
    role: "tabpanel",
    id: tabId && "".concat(tabId, "~panel"),
    "aria-labelledby": tabId && "".concat(tabId, "~tab"),
    tabIndex: shouldShow ? 0 : -1 // don't allow hidden tab content to be focused by tabbing
    ,
    "aria-hidden": !shouldShow,
    className: shouldShow ? undefined : 'hidden-xs-up'
  }, children);
}